<template>

  <div id="content" class="business_challenge_space" v-if="project.business_challenge_sharped">
    <ConfirmModal :dialogVisible='showConfirmDialog' @close="closeConfirmDialog()" @confirmed="validateChallenge($event)" message="Are you sure? Once approved, the brief will be made available to the customer. " ></ConfirmModal>
    <div class="container "  v-if="!project.business_challenge_sharped.isExpertSubmit">
       <div class="pt50 ">
        <div class="alert alert-warning">
          This challenge brief is currently being analyzed by the assigned expert.
        </div>
      </div>
    </div>
    <div class="container">
    <div class="bussiness_challenge_stepper">
       <button :class="[
        'step',
        (step == 1) ? 'active' : '',
      ]"  @click="save(false);step = 1;">
        <span class="stepNumber ">1</span> <span class="stepName">Business challenge</span>
      </button>
      <button :class="[
        'step',
        (step == 2) ? 'active' : '',
      ]"  @click="save(false);step = 2;" >
        <span class="stepNumber">2</span> <span class="stepName">Case for innovation</span>
      </button>
      <button :class="[
        'step',
        (step == 3) ? 'active' : '',
      ]"  @click="save(false);step =3;" >
        <span class="stepNumber">3</span> <span class="stepName">Execution factors</span>
      </button>
    </div>


     <div class=" business_challenge_space_1" v-if="step == 1">
      <div class="row space_title_zone">
        <div class="col-12">
          <span class="space_title">Business Challenge</span>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-6 mt20">
          <div class="zone_input">
            <div class="zone_input_header">
              <img :src="require('@/assets/start_a_new_project_project_name.svg')" class="zone_input_icon" alt="">
              <span class="zone_input_name">Project name</span>
            </div>
            <input type="text" class="innopearl_input" v-model="project.name" >
          </div>
        </div>
        <div class="col-12 col-lg-6 mt20">
          <div class="zone_input">
            <div class="zone_input_header">
              <img :src="require('@/assets/start_a_new_project_business_opportunity.svg')" class="zone_input_icon" alt="">
              <span class="zone_input_name">Business opportunity</span>
            </div>
            <textarea  v-model="project.business_challenge_sharped.business_opportunity" placeholder="What is your business challenge or key question you want to answer?" cols="20" rows='5'></textarea>
          </div>
        </div>
      </div>




      <div class="step_footer">
        <div class="row row_center">
          <div class="col-12 text-right">
            <button v-if="project.business_challenge_sharped.isSubmit != true" type="button" name="button" class="prev_step_btn" @click='save(true)'>
              Save
            </button>
            <button type="button" name="button" class="next_step_btn" @click='next_step()'>
              Next step
              <img :src="require('@/assets/next.svg')" alt="">
            </button>
          </div>
        </div>

      </div>
    </div>


    <div class=" business_challenge_space_2" v-if="step == 2">
      <div class="row space_title_zone">
        <div class="col-12">
            <span class="space_title">Sharpen the following sections if necessary</span>
        </div>
      </div>

      <div class="row ligne_form"  v-if="project.business_challenge">
        <div class="col-12 col-lg-6">
          <div class="zone_input">
            <div class="zone_input_header">
              <img :src="require('@/assets/complete_the_following_sections_what_would.svg')" class="zone_input_icon" alt="">
              <span class="zone_input_name">What would be the expected benefits / value of solving the challenge?</span>
            </div>
            <textarea  v-model="project.business_challenge_sharped.expected_benefits" placeholder="" cols="20" rows='5'></textarea>

          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="zone_input">
            <div class="zone_input_header">
              <img :src="require('@/assets/complete_the_following_sections_who_are.svg')" class="zone_input_icon" alt="">
              <span class="zone_input_name">Who are the targeted stakeholder(s) or/and end-users?</span>
            </div>
            <textarea  v-model="project.business_challenge_sharped.targeted_stakeholders" placeholder="" cols="20" rows='5'></textarea>

          </div>
        </div>
      </div>
      <div class="row ligne_form" v-if="project.business_challenge">
        <div class="col-12 col-lg-6">
          <div class="zone_input">
            <div class="zone_input_header">
              <img :src="require('@/assets/complete_the_following_sections_what_type.svg')" class="zone_input_icon" alt="">
              <span class="zone_input_name">What type of solution are you looking for? (ex. technology, ingredient, service)</span>
            </div>
            <textarea  v-model="project.business_challenge_sharped.type_of_solution" placeholder="" cols="20" rows='5'></textarea>

          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="zone_input">
            <div class="zone_input_header">
              <img :src="require('@/assets/complete_the_following_sections_additional.svg')" class="zone_input_icon" alt="">
              <span class="zone_input_name">Additional considerations?</span>
            </div>
            <textarea  v-model="project.business_challenge_sharped.additional_considerations" placeholder="" cols="20" rows='5' ></textarea>

          </div>
        </div>
      </div>
      <div class="row ligne_form" v-if="project._id">
        <div class="col-12">
            <div class="zone_input">

              <div class="list_file" v-if="project.business_challenge.brief_supporting_documents">


                <table class="table table_brief_doc">
                  <thead>
                    <tr>
                      <td colspan="2" class="text-center"><span class="zone_input_name">Your brief or supporting documents</span></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="" v-for="(doc,d) in project.business_challenge.brief_supporting_documents" :key="d">
                      <td> <a :href="this.apiUrl+'/get_file/'+doc._id.$oid+'?token='+$store.state.innotoken" target="_blank">{{doc.customer_filename}}</a></td>
                      <td class="text-right"> <a :href="this.apiUrl+'/get_file/'+doc._id.$oid+'?token='+$store.state.innotoken" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17 18c.56 0 1 .44 1 1s-.44 1-1 1s-1-.44-1-1s.44-1 1-1m0-3c-2.73 0-5.06 1.66-6 4c.94 2.34 3.27 4 6 4s5.06-1.66 6-4c-.94-2.34-3.27-4-6-4m0 6.5a2.5 2.5 0 0 1-2.5-2.5a2.5 2.5 0 0 1 2.5-2.5a2.5 2.5 0 0 1 2.5 2.5a2.5 2.5 0 0 1-2.5 2.5M9.27 20H6V4h7v5h5v4.07c.7.08 1.36.25 2 .49V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4.5a8.15 8.15 0 0 1-1.23-2Z"/></svg></a></td>
                    </tr>
                  </tbody>

                </table>

              </div>
            </div>
        </div>

      </div>

      <div class="step_footer">
          <div class="row row_center">
          <div class="col-12 col-xl-6 text-left">
            <button type="button" name="button" class="prev_step_btn" @click='prev_step()'>
              <img :src="require('@/assets/prev.svg')" alt="">
              Previous step
            </button>
          </div>
          <div class="col-12 col-xl-6 text-right">
            <button v-if="project.business_challenge_sharped.isSubmit != true" type="button" name="button" class="prev_step_btn" @click='save(true)'>
              Save
            </button>
            <button type="button" name="button" class="next_step_btn" @click='next_step()'>
              Next step
              <img :src="require('@/assets/next.svg')" alt="">
            </button>
          </div>
        </div>

      </div>
    </div>

    <div class=" business_challenge_space_3" v-if="step == 3">
      <div class="row space_title_zone">
        <div class="col-12">
          <span class="space_title">COMPLETE THE FOLLOWING SECTIONS TO THE BEST OF YOUR KNOWLEDGE</span>

        </div>
      </div>
      <div class="row ligne_form">
        <div class="col-12 col-md-12">
            <div class="zone_input">
              <div class="zone_input_header">
                <img :src="require('@/assets/complete_the_following_sections2_partnership_objectives.svg')" class="zone_input_icon" alt="">
                <span class="zone_input_name">PARTNERSHIP OBJECTIVES</span>
              </div>
              <div class="zone_input_subheader">
                <span class="zone_input_subname">Choose all that will most likely apply :</span>
              </div>
              <div class="zone_input_checkboxes">
                <label :for="o.value" class="partnership_objectives_label" v-for='(o,i) in objectifs_possibles' :key='i'>
                  <span>{{o.name}}</span>
                  <div class="checkbox_container">
                    <input type="checkbox" :id="o.value" :value='o.value' v-model="project.business_challenge_sharped.partnership_objectives" name="partnership_objectives" >

                  </div>
                </label>
                <div class="partnership_objectives_label add_other_objectif" v-if="project.business_challenge_sharped.isSubmit != true">
                  <span>Or add other :</span>
                    <input type="name" v-model="add_other_objectif"/>
                    <div class="checkbox_container">
                      <button type="button" name="button" @click="addOtherObjectif">OK</button>

                    </div>
                </div>

              </div>
            </div>
      </div>
    </div>
    <div class="row ligne_form">

          <div class="zone_input">
            <div class="zone_input_header">
              <img :src="require('@/assets/complete_the_following_sections2_key_execution_factors.svg')" class="zone_input_icon" alt="">
              <span class="zone_input_name">KEY EXECUTION FACTORS</span>
            </div>
          </div>
              <div class="col-12 col-xl-6 mt20">
          <div class="zone_input">
            <div class="zone_input_subheader">
              <span class="zone_input_subname">What internal assets or capabilities would you bring to the table?</span>
            </div>
            <div class="vselect_container">
              <v-autocomplete v-model="project.business_challenge_sharped.internal_assets" closable-chips  :items="key_execution_factors_possibles" item-color="#FFF" item-title="name" item-value="value"  chips multiple></v-autocomplete>
              <div class="add_custom_key_factor" v-if="project.business_challenge_sharped.isSubmit != true">
                <span>You don’t find what you are looking for ?</span>
                <button type="button" name="button" @click='dialog = true'>+ ADD</button>
                <NewValueModal :dialogVisible='dialog' @close="dialog=false" @newValueIsProposed="setNewValueKEF($event)" formName="Add your own key execution factor" ></NewValueModal>
              </div>
            </div>
          </div>
          </div>
          <div class="col-12 col-xl-6 mt20">
      <div class="zone_input">
        <div class="zone_input_subheader">
          <span class="zone_input_subname">What are your internal constraints?</span>
        </div>
        <textarea  v-model="project.business_challenge_sharped.internal_constraints" placeholder="" cols="20" rows='5' ></textarea>


      </div>
      </div>

      <div class="row ligne_inner_form">
        <div class="col-12 col-xl-4 flex-column-align-input-bottom">
          <span class="zone_input_subname">When should this project start?</span>
          <div class="vselect_container" >
            <v-autocomplete v-model="project.business_challenge_sharped.timeline" :items="timeline_possibles" item-title="name" item-value="value"></v-autocomplete>
          </div>
        </div>
        <div class="col-12 col-xl-4 flex-column-align-input-bottom">
          <span class="zone_input_subname">Execution Geography</span>
          <div class="vselect_container">
              <!-- <v-autocomplete v-model="project.business_challenge_sharped.execution_geography" :items="execution_geography_possibles" item-title="en" item-value="alpha2" multiple chips :disabled="project.business_challenge_sharped.isSubmit">

              </v-autocomplete> -->
              <treeselect v-model="project.business_challenge_sharped.execution_geography" :multiple="true" :options="execution_geography_possibles" />

              <!-- <treeselect v-model="project.execution_geography" :multiple="true" :options="execution_geography_possibles"  :normalizer="normalizer" /> -->
          </div>
        </div>
        <div class="col-12 col-xl-4 flex-column-align-input-bottom">
          <span class="zone_input_subname">Which level of management is sponsoring this project?</span>
          <div class="vselect_container">
            <v-autocomplete v-model="project.business_challenge_sharped.business_sponsorship"  :items="business_sponsorship_possibles" item-title="name" item-value="value" ></v-autocomplete>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row ligne_form">
      <div class="col-12 col-xl-6">
          <div class="zone_input">
            <div class="zone_input_header">
              <img :src="require('@/assets/complete_the_following_sections2_search_fields.svg')" class="zone_input_icon" alt="">
              <span class="zone_input_name">SEARCH FIELDS</span>
            </div>
            <div class="zone_input_subheader">
              <span class="zone_input_subname">Specific areas of interest</span>
            </div>
            <div class="inputs_container">
              <div class="search_field_input" v-for="(sf,i) in project.search_field" :key="i">
                <input type="text" class="innopearl_input" v-model="project.search_field[i].name" :disabled="project.business_challenge_sharped.isSubmit"/>
              </div>
              <div class="add_custom_key_factor_without_text" v-if="project.business_challenge_sharped.isSubmit != true">
                <button type="button" name="button" @click='addMoreSearchField()'>+ ADD</button>
              </div>
            </div>





          </div>
      </div>
    </div> -->


    <div class="step_footer">

        <div class="row row_center">
        <div class="col-12 col-xl-6 text-left">

          <button type="button" name="button" class="prev_step_btn" @click='prev_step()'>
            <img :src="require('@/assets/prev.svg')" alt="">
            Previous step
          </button>

        </div>
        <div class="col-12 col-xl-6 text-right">
          <button  type="button" name="button" class="prev_step_btn" @click='save(true)'>
            Save
          </button>
          <button  v-if="project.business_challenge_sharped.isAdminSubmit != true" type="button" name="button" class="next_step_btn" @click="showConfirmDialog=true">
            Submit
            <img :src="require('@/assets/next.svg')" alt="">
          </button>
        </div>
      </div>

    </div>
      </div>

  </div>
</div>

</template>
<script>
import NewValueModal from '@/components/modals/addValue.vue'
import { toast } from 'vue-sonner'
import api from '@/tools/api';
import _ from 'lodash';
import { toRaw } from 'vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import countries from '@/assets/db_coutries.json';
import Treeselect from 'vue3-treeselect'
// import the styles
import 'vue3-treeselect/dist/vue3-treeselect.css'

export default {
  components: {
    NewValueModal,
    ConfirmModal,
    Treeselect
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      add_other_objectif: "",
      dialog : false,
      showConfirmDialog: false,
      step: 1,
      pageInfo: {
        mainTitle : "Business Challenge Space",
        subTitle : "Define your challenge brief",
      },

      objectifs_possibles: [
        {
          name: "Co-develop",
          value: "co-develop"
        },
        {
          name: "Buy a solution",
          value: "Buy"
        },
        {
          name: "Invest",
          value: "Invest"
        },
        {
          name: 'Integrate into partner ecosystem',
          value: 'Integrate'
        }
      ],
      key_execution_factors_possibles: [
        {
          name: "R&D FACILITIES",
          value: "rd"
        },
        {
          name: "FINANCIAL SUPPORT",
          value: "financial"
        },
        {
          name: "Key factor",
          value: "other"
        },
      ],
      timeline_possibles: [
        {
          name: "< 12 MONTHS",
          value: "12months"
        },
        {
          name: "2 YEARS",
          value: "2years"
        },
        {
          name: "5 YEARS +",
          value: "5years"
        },
      ],
      execution_geography_possibles: countries,

      business_sponsorship_possibles: [
        {
          name: "BOard",
          value: "toto"
        },
        {
          name: "Board",
          value: "board2"
        },
        {
          name: "Board",
          value: "board3"
        },
      ],

      project: {
        business_challenge: {
          isSubmit : false,
          partnership_objectives: []
        },
        search_field: [{name:""}],
      },
    }
  },
  methods:{
    gobackrouter : function(){
      this.$router.go('/admin/project/'+this.project._id.$oid);
    },
    addMoreSearchField(){
      this.project.search_field.push({name:""});
    },
    addOtherObjectif(){
      if(this.add_other_objectif != ''){
        api.post(process.env.VUE_APP_API_URL+"/restrict/dict",
          {
              dict: 'dict_partnership_objectives',
              value: this.add_other_objectif
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          this.objectifs_possibles .push(r.data)
          this.project.business_challenge_sharped.partnership_objectives.push(this.add_other_objectif);
          this.add_other_objectif = "";
        }).catch( (e) => {
        if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
        else toast.error("Sorry an error occurs !")
        });

      }

    },
    closeConfirmDialog(){
      this.showConfirmDialog = false;
    },
    setNewValueKEF(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/dict",
          {
              dict: 'dict_key_exection_factors',
              value: v
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          this.key_execution_factors_possibles.push(r.data)
          if(!this.project.business_challenge_sharped.internal_assets) this.project.business_challenge_sharped.internal_assets = [];
          this.project.business_challenge_sharped.internal_assets.push(v);
        }).catch( (e) => {
          console.log(e);
        toast.error("Sorry an error occurs !")
        });
      }
      this.dialog = false;
    },
    isBusinessChallengeValid(){
      var errorMsg = [];
      var isValid = true;
      let rawProject = toRaw(this.project)
      if(!rawProject.name){
        errorMsg.push("Project name is required");
        isValid = false;
      }
      // if(rawProject.search_field[0].name == "")return false;
      // if(!rawProject.business_challenge_sharped.business_opportunity)return false;
      if(!rawProject.business_challenge_sharped.expected_benefits){
          errorMsg.push("Expected benefits field is required");
        isValid = false;
      }
      // if(!rawProject.business_challenge_sharped.targeted_stakeholders){
      //     errorMsg.push("Target stakeholder(s) field is required"),
      //   isValid = false;
      // }
      // if(!rawProject.business_challenge_sharped.type_of_solution){
      //     errorMsg.push("Type of solution field is required");
      //   isValid = false;
      // }
      // if(!rawProject.business_challenge_sharped.additional_considerations){
      //     errorMsg.push("A is required");
      //   isValid = false;
      // }
      if(!rawProject.business_challenge_sharped.partnership_objectives){
          errorMsg.push("Partnership objectives field is required");
        isValid = false;
      }
      if(!rawProject.business_challenge_sharped.internal_assets){
        errorMsg.push("Internal assets field is required");
        isValid = false;
      }
      // if(!rawProject.business_challenge_sharped.internal_constraints){
      //     errorMsg.push("Internal constraints field is required");
      //   isValid = false;
      // }
      if(!rawProject.business_challenge_sharped.timeline){
          errorMsg.push("Project timeline is required");
        isValid = false;
      }
      if(!rawProject.business_challenge_sharped.execution_geography){
          errorMsg.push("Project execution geography is required");
        isValid = false;
      }
      if(!rawProject.business_challenge_sharped.business_sponsorship){
        errorMsg.push("Level of management field is required");
        isValid = false;
      }
      return {
      'isValid' : isValid,
      'errorMsg' : errorMsg
      };
    },
    validateChallenge(){
      this.showConfirmDialog = false;
      var validateObj = this.isBusinessChallengeValid();
      if(validateObj.isValid){
        toast.promise(() => new Promise((resolve,reject) => {
          api.post(process.env.VUE_APP_API_URL+"/restrict/adminsubmit_business_challenge",this.project,{
              headers: {
                  'Content-Type': 'application/json',
              }
          }).then( (r) => {
              console.log("pifqsopfiqs", r);
            resolve();

          }).catch( () => {
             reject(new Error("Error!"));
          });
        }), {
        loading: 'Business challenge submission in progress. Please wait an instant ... ',
        success: () => {
          //this.$store.commit('UPDATE_NOTIFICATION',1);
           this.$router.push('/admin/project/'+this.project._id.$oid);
           this.$store.commit('UPDATE_PROJECTS',this.project)
          return 'Business challenge successfully submited'
        },
        error: () => 'Error during business challange submission.'
      });
      }
      else{


        toast.error("Errors",{description:validateObj.errorMsg.join(', ')});
      }


    },
    fileIsUpload(e){
      console.log(e);
      if(!this.project.business_challenge_sharped.brief_supporting_documents) this.project.business_challenge_sharped.brief_supporting_documents = [];
              this.project.business_challenge_sharped.brief_supporting_documents.push(e);
    },
    normalizer(node) {
      return {
        id: node.value,
        label: node.name,
      }
    },
    save(notify){

      if(this.project.business_challenge_sharped.isSubmit != true ){
        api.post(process.env.VUE_APP_API_URL+"/restrict/adminsave_project",this.project,{
            headers: {
                'Content-Type': 'application/json',
            }
        }).then( () => {
            if(notify)toast.success("Project saved ! ")
             this.$store.commit('UPDATE_PROJECTS',this.project)
             this.reloadP();

        }).catch( () => {
            toast.error("There is an error during project update !")
        });
      }
      if(this.project.business_challenge_sharped.isSubmit == true ){
        api.post(process.env.VUE_APP_API_URL+"/restrict/adminsave_project_bothBusinessChallenge",this.project,{
            headers: {
                'Content-Type': 'application/json',
            }
        }).then( () => {
            if(notify)toast.success("Project saved ! ")
             this.$store.commit('UPDATE_PROJECTS',this.project)

             this.reloadP();
        }).catch( () => {
            toast.error("There is an error during project update !")
        });
      }
    },


    next_step(){
      this.save(false);
      this.step++;
    },
    prev_step(){
      this.save(false);
      this.step--;
    },

    seeDoc(doc){
        console.log(doc);
        api.get(process.env.VUE_APP_API_URL+"/restrict/get_file/"+doc.$oid).then( (r) => {
          console.log(r);
        })
    },
    reloadP(){
      api.get(process.env.VUE_APP_API_URL+"/restrict/project/"+this.$route.params.projectid).then( (r) => {
        // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
         console.log(r);
        var d = JSON.parse(r.data);
        var temp = _.merge(this.project, d)
        this.project = temp;
      });
    }


  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

   api.get(process.env.VUE_APP_API_URL+"/restrict/project/"+this.$route.params.projectid).then( (r) => {
     // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
      console.log(r);
     var d = JSON.parse(r.data);
     var temp = _.merge(this.project, d)
     this.project = temp;
     console.log(this.project);
        api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_partnership_objectives/"+this.project.user.$oid).then( (r) => {
          this.objectifs_possibles = r.data
        }).catch( (e) => {
        if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
        else toast.error("Sorry an error occurs !")
        });
        api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_key_exection_factors/"+this.project.user.$oid).then( (r) => {
          console.log(r);
          this.key_execution_factors_possibles = r.data
        }).catch( (e) => {
        if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
        else toast.error("Sorry an error occurs !")
        });
        api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_timeline/"+this.project.user.$oid).then( (r) => {
          console.log(r);
          this.timeline_possibles = r.data
        }).catch( (e) => {
        if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
        else toast.error("Sorry an error occurs !")
        });
        api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_level_of_management/"+this.project.user.$oid).then( (r) => {
          console.log(r);
          this.business_sponsorship_possibles = r.data
        }).catch( (e) => {
        if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
        else toast.error("Sorry an error occurs !")
        });
   }).catch( (e) => {
   if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
   else toast.error("Sorry an error occurs !")
 });

},
watch: {
  step() {
      window.scrollTo(0, 0)
  }
}
}
</script>
<style scoped>


.bussiness_challenge_stepper{
  display: flex;
  gap: 20px;
  justify-content: center;
  padding: 50px;

}
.bussiness_challenge_stepper .step{
  border-bottom: 1px solid #ADB3B5;
  position : relative;
  flex: 1;
  text-align: center;
  padding: 10px;
}
.bussiness_challenge_stepper .step.active{
    border-bottom: 2px solid #3783C5;
}
.bussiness_challenge_stepper .active:after{
  content: '';
position: absolute;
left: calc(50% - 15px);
top: 100%;
width: 0;
height: 0;
border-left: 15px solid transparent;
border-right: 15px solid transparent;
border-top: 15px solid #3783C5;
clear: both;
}
.bussiness_challenge_stepper .stepNumber{
  font-size: 36px;
  line-height: 44px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.bussiness_challenge_stepper .stepName{
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.bussiness_challenge_stepper .active .stepNumber,
.bussiness_challenge_stepper .active .stepName
{
  color: #3783C5;
}


.business_challenge_space_1,
.business_challenge_space_2,
.business_challenge_space_3{
  padding: 50px;
  background: #FFF;
}
.space_title_zone{
  margin-bottom: 50px;
}
.space_title{
  text-align: left;
  font-size: 21px;
  line-height: 25px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
opacity: 1;
display: block;
}
.zone_input{
}
.zone_input_icon{
  width: 55px;
}
.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: #3783C5;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  align-items: center;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: calc(100% - 65px);
box-sizing: border-box;
margin-top:20px;
margin-bottom: 20px;
height: 40px;
padding: 5px;
margin-left: 65px;
}
@media screen and (max-width: 690px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}
textarea{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: calc(100% - 65px);
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 margin-left: 65px;
}


.step_footer{
  /* display:flex;
  margin-top: 50px;
  align-items: center; */
  margin-top: 50px;
}
.step_footer .notice{
  flex: 1;
  font-size:14px;
  line-height: 22px;
  font-weight: 300;
}
.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img{
  margin-left:10px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}

.business_challenge_space_2 .row{
  margin-top:25px;
  margin-bottom: 25px;
}

.zone_input_subname{
  text-align: left;
  font-size:16px;
  line-height: 22px;
letter-spacing: 0px;
color: #3783C5;
margin-left: 65px;
-webkit-box-decoration-break: clone;
box-decoration-break: clone;
}
.zone_input_checkboxes{
  margin-left: 65px;
  width: calc(100% - 65px);
  display: flex;
  margin-top:20px;
  gap: 20px;
  flex-wrap: wrap;
}

.partnership_objectives_label{
  padding:12px 30px;
  background: #EFEFEF 0% 0% no-repeat padding-box;
border-radius: 3px;
min-width: calc(20% - 20px);
max-width: calc(20% - 20px);
flex-basis: 0;
flex: 1;
display:flex;
flex-direction: column;
gap: 10px;
border: 1px solid #EFEFEF;
}

@media screen and (max-width: 990px){
  .partnership_objectives_label{
    min-width: calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
}

@media screen and (max-width: 690px){
  .partnership_objectives_label{
    min-width: calc(100% - 20px);
    max-width: calc(100% - 20px);
  }
}
input[type='checkbox']{
  width: 24px;
height: 24px;
margin-top:auto;
}
.checkbox_container{
  width:100%;
  display:block;
  text-align: right;
  align-self: end;
margin-top: auto;
}
.partnership_objectives_label.add_other_objectif{
background:#FFF;
}
.add_other_objectif input{
  border:1px solid #EFEFEF;
  padding: 5px;
}
.checkbox_container button{
  font-size: 18px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
}
.ligne_form{
  margin-top: 50px;
}

.vselect_container{
  margin-top: 20px;
}
.vselect_container .v-field{
  background: #FFF !important;
  border: 1px solid #CCC;
}
.vselect_container .v-field__field,
.vselect_container .v-field__append-inner{
    background: #FFF !important;
}
.v-field--variant-filled .v-field__overlay {
  opacity: 0 !important;
}
.vselect_container .v-field__append-inner i {
  color: #3783C5;
}
.add_custom_key_factor{
  display: flex;
  justify-content: center;
}
.add_custom_key_factor_without_text{
  display: flex;
  justify-content: flex-end;
}
.add_custom_key_factor span{
  font-size: 16px;
  line-height: 22px;
  font-weight: 300;
  flex-grow: 1;
}
.add_custom_key_factor button,
.add_custom_key_factor_without_text button{
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: #3783C5;
text-transform: uppercase;
}
.ligne_inner_form{
  margin-top:40px;
}
.inputs_container{
  margin-left: 65px;
}
.vselect_container,
.ligne_inner_form .vselect_container{
  margin-left:65px;
}
.v-autocomplete .v-field .v-field__input{
  padding: 7px;
min-height: 40px;

}
.search_field_input input{
  margin-top: 10px;
  margin-bottom: 10px;
}

.row_center{
  align-items: center;
}

.flex-column-align-input-bottom{
  display:flex;
  flex-direction: column;
}
.flex-column-align-input-bottom .zone_input_subname{
  margin-bottom: 10px;
}
.flex-column-align-input-bottom > .vselect_container,
.flex-column-align-input-bottom >  .vue-treeselect__control{
  margin-top: auto;
}

@media screen and (max-width:690px){
  textarea{
   margin-left: 0;
   width: 100%
  }
  .zone_input_subname{
    margin-left:0;
    margin-top: 10px;
  }
  .zone_input_checkboxes{
    margin-left: 0 !important;
    width:100%;
  }
  .vselect_container{
    margin-left: 0 !important;
  }
  .inputs_container{
    margin-left: 0 !important;
  }
  .business_challenge_space_1,
  .business_challenge_space_2,
  .business_challenge_space_3{
    padding-left:10px;
    padding-right:10px;
  }
}

</style>
<style media="screen">
.vue-treeselect__control{
  background: #CCC;
  height: 60px;
}

.vue-treeselect__multi-value-item{
  align-items: center;
cursor: default;
display: inline-flex;
font-weight: 400;
max-width: 100%;
min-width: 0;
overflow: hidden;
position: relative;
text-decoration: none;
white-space: nowrap;
vertical-align: middle;
border-color: rgba(var(--v-border-color), var(--v-border-opacity));
border-style: solid;
border-width: 0;
border-radius: 9999px;
font-size: 0.75rem;
padding: 4px 10px;
height: calc(var(--v-chip-height) + 0px);
color: #000;
}
.vue-treeselect__icon ,
.vue-treeselect__icon:hover {
  cursor: pointer;
flex: 0 1 auto;
font-size: 18px;
max-height: 18px;
max-width: 18px;
-webkit-user-select: none;
-moz-user-select: none;
user-select: none;
color: #FFF !important;
background: #000;
border-radius: 60%;
padding: 5px;
margin-inline-start: 5px;
-webkit-margin-end: -5px;
margin-inline-end: -5px;
}
.vue-treeselect__x-container{
  display:none;
}
.vue-treeselect__control-arrow-container{
  display: flex;
}
.mt20{
  margin-top:20px;
}
.briefUploader{
  cursor:pointer;
}
.briefUploader input[type="file"]{
  display:none;
}
.table_brief_doc{
  margin-top:20px;
}
.table_brief_doc thead td{
  background: #EEE;
  padding-top:10px;
  padding-bottom:10px;
}
.table_brief_doc tbody{
  border:1px solid #EEE;
}
.table_brief_doc a{
  color: inherit;
}
.table_brief_doc svg{
  color: #3783C5
}
.pt50{
  padding-top: 50px;
}

.flex-column-align-input-bottom .vselect_container{
  height:100px;
}
</style>
